<template>
    <section id="home" class="section welcome-area bg-overlay overflow-hidden d-flex align-items-center">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-12 col-md-6 order-2 order-md-1">
                        <!-- Welcome Thumb -->
                        <div class="welcome-thumb mx-auto">
                            <img src="assets/img/welcome_mockup_2.png" alt="">
                        </div>
                    </div>
                    <!-- Welcome Intro Start -->
                    <div class="col-12 col-md-6 order-1 order-md-2">
                        <div class="welcome-intro px-0 px-lg-4">
                            <h1 class="text-white mb-2 mb-md-3">Just bring content.</h1>
                            <h3 class="text-white text-capitalize">Instant, zero-maintenace audience site.</h3>
                            <p class="text-white mt-3 mb-4">Are you a content creator with a growing audience, looking to further engage and monitize so you can take things to the next level?<br/>Don't waste your effort building a custom platform for your viewers. Get up and running with a FREE solution that scales like magic so you can get back to doing what you love; making your audience happy!</p>
                            <!-- Store Buttons -->
                            <div class="button-group store-buttons d-flex">
                                <a href="#">
                                    <img src="assets/img/google_play.png" alt="">
                                </a>
                                <a href="#">
                                    <img src="assets/img/app_store.png" alt="">
                                </a>
                            </div>
                            <span class="d-inline-block text-white fw-3 font-italic mt-3">* Available on iPhone, iPad and all Android devices. For OTT devices like Roku or AppleTV, check out <a href="/turnkey-ott" style="color: white;text-decoration:underline;">Turnkey OTT</a>.</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
</template>

<script>
export default {
    
}
</script>

<style>

</style>